module.exports = __webpack_public_path__ + "static/img/commodity_sing01.defb12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/malls/commodity_sing01.png
// module id = Q6xQ
// module chunks = 174